/**
 * 路由名称常量
 * 统一管理所有路由名称，避免硬编码
 */
export const RouteNames = {
  // 数据看板
  DataSummary: 'DataSummary',
  DataOverview: 'DataOverview',
  HeadhunterBoard: 'HeadhunterBoard',
  InternalBoard: 'InternalBoard',
  MyBoard: 'MyBoard',

  // 职位管理
  JobManage: 'JobManage',
  Job: 'Job',
  JobForm: 'JobForm',
  JobFormEdit: 'JobFormEdit',
  JobDetail: 'JobDetail',
  AgentManage: 'AgentManage',
  AgentJobList: 'AgentJobList',
  BusinessManage: 'BusinessManage',

  // 沟通
  Chat: 'HeadhunterChat',

  // 候选人管理
  Candidate: 'Candidate',
  CandidateSelecting: 'CandidateSelecting',
  CandidateSelectingDetail: 'CandidateSelectingDetail',
  CandidateRegistered: 'CandidateRegistered',
  CandidateDetail: 'CandidateDetail',
  CandidateEdit: 'CandidateEdit',
  CandidateInterviewDetail: 'CandidateInterviewDetail',

  // 设置
  Settings: 'Settings',
  Account: 'Account',
  AccountDetail: 'AccountDetail',
  CompanySetting: 'CompanySetting',
  DepartmentSetting: 'DepartmentSetting',
  Notify: 'Notify',
  NotifySettings: 'NotifySettings',

  // 选考设置
  InterviewSetting: 'InterviewSetting',
  InterviewSettingAgent: 'InterviewSettingAgent',
  InterviewProcess: 'InterviewProcess',
  InterviewProcessDetail: 'InterviewProcessDetail',
  InterviewChannel: 'InterviewChannel',

  // 错误页面
  Error403: '403',
  Error404: '404',
} as const

/**
 * 导出路由名称类型
 */
export type RouteName = typeof RouteNames[keyof typeof RouteNames]
